import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { UserState } from '@client/utils/shared-constants';
import { EMPTY, from, Observable } from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';
import firebase from 'firebase';
import User = firebase.User;

@Injectable()
export class UserService {

  itemsRef: AngularFireList<UserState> | Observable<never>;

  constructor(private db: AngularFireDatabase, private auth: AngularFireAuth) {
    auth.authState
      .pipe(
        tap((u: User) => {
          this.itemsRef = u ? this.db.list<UserState>(`/user/${u.uid}`) : EMPTY;
        })
      )
      .subscribe();
  }

  delete() {
    return this.auth.user.pipe(
      switchMap((u: User) => u.delete())
    );
  }

  hydrate() {
    return this.auth.user.pipe(
      switchMap((u: User) => u ? this.db.object<UserState>(`/user/${u.uid}`).valueChanges() : EMPTY)
    );
  }
}
